import {
  DownloadFileParams,
  DownloadFileResponse,
  HandleCollectionRequestParams,
  HandleFileRequestParams,
  UploadFileFormDataParamsSchema,
} from '@stellab/cs-schemas';
import { AxiosRequestConfig } from 'axios';

import config from '@/config';
import { getAxios } from './axios';

export const handleDamDownload = (data: DownloadFileParams, options?: AxiosRequestConfig) => {
  const url = `${config.backend}/dam/download`;

  const baseOptions: AxiosRequestConfig = {
    responseType: 'arraybuffer',
  };

  const requestOptions = options ? { ...baseOptions, ...options } : baseOptions;

  return getAxios().post<DownloadFileResponse>(url, data, requestOptions);
};

export const handleDamUpload = (data: FormData, options?: AxiosRequestConfig) => {
  try {
    UploadFileFormDataParamsSchema.parse(data);
  } catch (error) {
    throw new Error(`Invalid form data`);
  }

  const url = `${config.backend}/dam/upload`;

  return getAxios().post(url, data, options);
};

export const handleDamFileTransfer = (data: HandleFileRequestParams) => {
  const url = `${config.backend}/dam/handle-file-request`;

  return getAxios().post(url, data);
};

export const handleDamCollectionTransfer = (data: HandleCollectionRequestParams) => {
  const url = `${config.backend}/dam/handle-collection-request`;

  return getAxios().post(url, data);
};
